import { Component, ElementRef, Output, ViewChild, EventEmitter, Input } from '@angular/core';
import { MockEvent, PhotoData } from '../interfaces/dialog-configuration.interface';

@Component({
  selector: 'app-camera',
  templateUrl: './camera.component.html',
  styleUrls: ['./camera.component.scss']
})
export class CameraComponent {
  @ViewChild("camera") camera!: ElementRef;
  @ViewChild("videoContent") videoContent!: ElementRef;

  @ViewChild("actionPhoto") actionPhoto!: ElementRef;
  @ViewChild("actionConfirm") actionConfirm!: ElementRef;

  isCameraOpen: boolean = false;
  isValidatingPhoto: boolean = false;
  documentImages : Map<number, string> = new Map();
  validatingImages : Map<number, boolean> = new Map();
  messageText: string = 'Toma la fotografía';

  @Input() currentDocumentTypeId: number = 0;
  @Output() confirmPhotoEmitter: EventEmitter<PhotoData> = new EventEmitter();

  captureFrame() {
    let video = this.camera.nativeElement
    let canvas = document.createElement("canvas");
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    let canvasContext = canvas.getContext("2d");
    canvasContext?.drawImage(video, 0, 0);
    const imageBase64 = canvas.toDataURL('image/png');
    return imageBase64
  }

  openCamera(messageText: string) {
    this.messageText = messageText;
    this.isValidatingPhoto = false;
    this.actionPhoto.nativeElement.style.display = 'block';
    this.actionConfirm.nativeElement.style.display = 'none';

    navigator.mediaDevices.getUserMedia({ video: {facingMode: 'environment'}, audio: false })
      .then((stream) => {
        this.camera.nativeElement.srcObject = stream;
        this.camera.nativeElement.play();
        this.videoContent.nativeElement.style.display = 'block';
        this.isCameraOpen = true;
      })
      .catch((err) => {
        console.error("Error accessing the camera: ", err);
        this.isCameraOpen = false;
        this.videoContent.nativeElement.style.display = 'none';
      });
  }

  closeCamera() {
    this.camera.nativeElement.pause();

    if (this.camera.nativeElement.srcObject) {
      this.camera.nativeElement.srcObject.getTracks().forEach((track: MediaStreamTrack) => {
        if (track.readyState == 'live' && track.kind === 'video') {
          track.stop();
        }
      });
    }

    this.camera.nativeElement.srcObject = null;
    this.videoContent.nativeElement.style.display = 'none';
    this.isCameraOpen = false;
  }

  takePhoto() {
    this.camera.nativeElement.pause();

    this.isValidatingPhoto = true;
    this.actionPhoto.nativeElement.style.display = 'none';
    this.actionConfirm.nativeElement.style.display = 'block';
  }

  confirmPhoto() {
    const photo = this.captureFrame();

    // Convert base64 image to Blob.
    const byteString = atob(photo.split(',')[1]);
    const mimeString = photo.split(',')[0].split(':')[1].split(';')[0];

    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }

    const blob = new Blob([ab], { type: mimeString });

    // Create a File object that you can pass to loadDocument.
    const file = new File([blob], `document_${this.currentDocumentTypeId}.png`, { type: mimeString });

    // Create a simulated event to send the file.
    const mockEvent: MockEvent = { target: { files: [file] } };

    // Emit the photo data to the parent component.
    const photoData: PhotoData = { file: file, mockEvent: mockEvent };

    this.confirmPhotoEmitter.emit(photoData);

    // Reset the camera and close the interface.
    this.validatingImages.set(this.currentDocumentTypeId, true);
    this.closeCamera();
  }


  retryPhoto() {
    this.isValidatingPhoto = false;
    this.camera.nativeElement.play();
    this.actionPhoto.nativeElement.style.display = 'block';
    this.actionConfirm.nativeElement.style.display = 'none';
  }

  downloadPhoto(documentTypeId: number) {
    if (this.validatingImages.get(documentTypeId)) return;

    const photo = this.documentImages.get(documentTypeId);
    if (photo) {
      let aDownloadLink = document.createElement('a');
      aDownloadLink.download = `document_${documentTypeId}.png`;
      aDownloadLink.href = photo;
      aDownloadLink.click();
      aDownloadLink.remove();
    } else {
      console.error('No photo found for document type id: ', documentTypeId);
    }
  }
}
